import accountManagementIcon from "@assets/images/24-7-account-management-icon.png";
import checkMark from "@assets/images/check-mark.svg";
import inMallSupportIcon from "@assets/images/in-mall-support-icon-smo.png";
import launchPackageIcon from "@assets/images/launch-package-icon.png";
import smLogoWhite from "@assets/images/sm-logo-inverted.svg";
import smLogo from "@assets/images/smo-logo-rounded.svg";
import smWelcome from "@assets/images/SMO-Welcome.svg";
import OnlineStore from "@assets/images/smop-landing.png";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSavedAccount } from "@saleor/components/AppLayout/SavedAccountContext";
import {
  DEFAULT_INITIAL_SEARCH_DATA,
  IS_TOKEN_FROM_COOKIES
} from "@saleor/config";
import useNavigator from "@saleor/hooks/useNavigator";
import useMallSearch from "@saleor/searches/useMallSearch";
import { SmopStatusEnum } from "@saleor/types/globalTypes";
import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

import { chooseAccountPath, userLoginPath } from "../urls";
import { getTokenCookies, getTokens } from "./../utils";
import MenuListComposition from "./HomepageMenu";
const useStyles = makeStyles(
  {
    contactus: {
      "@media (max-width: 800px)": {
        display: "none"
      },
      color: "#fff",
      flex: 1,
      fontSize: "18px",
      padding: "0 30px",
      textDecoration: "none"
    },
    content: {
      "& p": {
        "@media (max-width: 768px)": {
          fontSize: "22px"
        },
        color: "#fff",
        fontSize: "24px",
        margin: 0
      },
      "@media (max-width: 1000px)": {
        padding: "0 20px",
        width: "100%"
      },
      "@media (max-width: 1200px)": {
        marginTop: "-20px"
      },
      "@media (max-width: 768px)": {
        flexDirection: "column",
        padding: "0 10px"
      },
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      margin: "-60px auto 0",
      padding: "0px 30px",
      width: "100%"
    },
    contentHeader: {
      "@media (max-width: 768px)": {
        padding: "20px"
      },
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      padding: "20px 30px",
      position: "relative",
      width: "100%"
    },
    formLabel: {
      color: "#0030FF",
      fontSize: "15px",
      fontWeight: "bold",
      textDecoration: "none"
    },
    formLinks: {
      "& span": {
        color: "#0030FF",
        fontWeight: 700,
        position: "relative",
        top: "11px"
      },
      "@media (max-width: 768px)": {
        display: "none"
      },
      backgroundColor: "#F0E700",
      borderRadius: "6px",
      display: "flex",
      justifyContent: "center",
      width: "230px"
    },
    left_content: {
      "@media (max-width: 1200px)": {
        width: "50%"
      },
      "@media (max-width: 768px)": {
        margin: "35px 0 0",
        padding: "0 10px",
        width: "100%"
      },
      width: "40%"
    },
    loginLink: {
      borderColor: "#FFF",
      color: "#FFF",
      display: "inline-block",
      fontSize: "18px",
      margin: "0 20px 80px",
      position: "absolute",
      right: "150px",
      textDecoration: "none",
      top: "60px"
    },
    logoContainer: {
      "@media (max-width: 768px)": {
        flex: 1
      },
      display: "flex"
    },
    mainPanel: {
      backgroundColor: "#96aaff",
      display: "flex",
      flexDirection: "column"
    },
    mall: {
      "& img": {
        display: "inline-block !important",
        marginRight: "10px",
        position: "relative",
        top: "5px"
      },
      "& span": {
        color: "#fff"
      },
      margin: "15px 6px",
      textAlign: "center"
    },
    mallCheck: {
      position: "relative",
      top: "5px",
      width: "20px"
    },
    malls: {
      "& .slick-next, & .slick-prev": {
        marginTop: "4px"
      },
      "& h3": {
        "@media (max-width: 768px)": {
          fontSize: "18px"
        },
        color: "#fff",
        fontSize: "20px",
        fontStyle: "italic",
        fontWeight: 600,
        margin: 0
      },
      "@media (max-width: 768px)": {
        margin: "40px auto 70px",
        width: "90%"
      },
      backgroundColor: "#5C7FFE",
      borderRadius: "20px",
      margin: "40px auto 150px",
      padding: "20px 60px",
      textAlign: "center",
      width: "85%"
    },
    onlineStoreImage: {
      width: "100%"
    },
    right_content: {
      "@media (max-width: 1000px)": {
        width: "50%"
      },
      "@media (max-width: 768px)": {
        padding: 0,
        width: "100%"
      },
      padding: "0px 30px",
      width: "60%"
    },
    root: {
      backgroundColor: "#FFF",
      flexGrow: 1
    },
    signup: {
      "@media (max-width: 768px)": {
        flexDirection: "column-reverse",
        textAlign: "center",
        width: "100%"
      },
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      margin: "0 auto",
      width: "980px"
    },
    signupContent: {
      "& a": {
        backgroundColor: "#0030FF",
        borderRadius: "6px",
        color: "#fff",
        fontSize: "16px",
        fontWeight: 600,
        padding: "10px 30px",
        position: "relative",
        textDecoration: "none"
      },
      "& p": {
        "@media (max-width: 1024px)": {
          fontSize: "45px",
          margin: "-100px 0 20px"
        },
        "@media (max-width: 768px)": {
          fontSize: "40px",
          lineHeight: "46px",
          margin: "0 0 10px",
          width: "350px"
        },
        color: "#0030FF",
        fontSize: "48px",
        fontStyle: "italic",
        fontWeight: 900,
        lineHeight: "60px",
        margin: "-180px 0 20px"
      }
    },
    signupWrapper: {
      "@media (max-width: 1024px)": {
        height: "290px"
      },
      "@media (max-width: 768px)": {
        height: "inherit",
        padding: "50px 50px 0"
      },
      backgroundColor: "#FFCE21",
      height: "360px",
      padding: "50px",
      position: "relative",
      width: "100%"
    },
    smFooter: {
      "& a": {
        display: "flex"
      },
      "& p": {
        "@media (max-width: 768px)": {
          maxWidth: "inherit"
        },
        "@media (min-width: 1600px)": {
          alignSelf: "center"
        },
        color: "#fff",
        margin: "10px 0 0",
        paddingLeft: "30px"
      },
      "@media (max-width: 768px)": {
        padding: "30px 20px"
      },
      display: "flex",
      padding: "30px",
      width: "100%"
    },
    smFooterLogo: {
      width: "61px"
    },
    smLogo: {
      height: "90px",
      width: "90px"
    },
    smOnline: {
      "& h3": {
        "@media (max-width: 768px)": {
          fontSize: "25px",
          fontWeight: 900,
          margin: "0 auto 10px",
          width: "320px"
        },
        color: "#0030FF",
        fontSize: "30px",
        margin: "0 0 10px"
      },
      "@media (max-width: 768px)": {
        padding: "80px 30px 50px"
      },
      backgroundColor: "#fff",
      minHeight: "350px",
      padding: "100px 50px 50px",
      textAlign: "center",
      width: "100%"
    },
    smOnlinesupport: {
      "& p": {
        "@media (max-width: 768px)": {
          fontSize: "18px",
          margin: "0 auto 30px",
          width: "320px"
        },
        color: "#0030FF",
        fontSize: "20px",
        fontWeight: 900,
        margin: 0
      },
      "@media (max-width: 768px)": {
        padding: 0,
        width: "100%"
      },
      padding: "0 30px",
      width: "33.33%"
    },
    smOnlinesupportImage: {
      width: "160px"
    },
    smOnlinesupports: {
      "& p": {
        color: "#0030FF"
      },
      "@media (max-width: 768px)": {
        flexDirection: "column"
      },
      display: "flex",
      flexDirection: "row",
      margin: "30px 0 0",
      width: "100%"
    },
    smWelcomeImage: {
      "@media (max-width: 1024px)": {
        width: "500px"
      },
      "@media (max-width: 768px)": {
        margin: "15px 0 0",
        position: "relative",
        top: "25px",
        width: "400px"
      },
      margin: "-150px 0 0",
      width: "600px"
    },
    welcome: {
      "@media (max-width: 1200px)": {
        fontSize: "50px"
      },
      "@media (max-width: 768px)": {
        fontSize: "40px"
      },
      color: "#F0E700",
      fontSize: "60px",
      fontStyle: "italic",
      fontWeight: 800,
      margin: "0 0 10px"
    }
  },
  { name: "Homepage" }
);

const Homepage: React.FC = props => {
  const classes = useStyles(props);
  const navigate = useNavigator();
  const searchMall = useMallSearch({
    variables: {
      ...DEFAULT_INITIAL_SEARCH_DATA,
      first: 100,
      status: SmopStatusEnum.ACT
    }
  });
  const { savedAccounts } = useSavedAccount();
  const activeMalls =
    searchMall &&
    searchMall.result &&
    searchMall.result.data &&
    searchMall.result.data.search &&
    searchMall.result.data.search.edges;
  const settings = {
    dots: false,
    infinite: activeMalls && activeMalls.length > 6,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          infinite: activeMalls && activeMalls.length > 4,
          slidesToShow:
            activeMalls && activeMalls.length < 4 ? activeMalls.length : 4
        }
      },
      {
        breakpoint: 1024,
        settings: {
          infinite: activeMalls && activeMalls.length > 3,
          slidesToShow:
            activeMalls && activeMalls.length < 3 ? activeMalls.length : 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          infinite: activeMalls && activeMalls.length > 1,
          slidesToShow:
            activeMalls && activeMalls.length < 1 ? activeMalls.length : 1
        }
      }
    ],
    slidesToScroll: 1,
    slidesToShow:
      activeMalls && activeMalls.length < 6 ? activeMalls.length : 6,
    speed: 500
  };
  const token = IS_TOKEN_FROM_COOKIES
    ? getTokenCookies().auth
    : getTokens().auth;

  if (
    (window.location.href === "https://omi-uat.smop.asia/" ||
      window.location.href === "https://omi.smop.asia/" ||
      window.location.href === "https://omi-uat.smop.asia" ||
      window.location.href === "https://omi.smop.asia") &&
    !token
  ) {
    if (savedAccounts.length) {
      navigate(chooseAccountPath);
    } else {
      navigate(userLoginPath);
    }
  }

  const handleLoginNavigation = () => {
    if (savedAccounts.length) {
      navigate(chooseAccountPath);
    } else {
      navigate(userLoginPath);
    }
  };

  return (
    <div className={classes.root}>
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
      />
      <link
        rel="stylesheet"
        type="text/css"
        href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
      />
      <div className={classes.mainPanel}>
        <div className={classes.contentHeader}>
          <Link to="/" className={classes.logoContainer}>
            <img className={classes.smLogo} src={smLogo} alt="SM Header Logo" />
          </Link>
          <Link to="/contact-us" className={classes.contactus}>
            Contact Us
          </Link>
          <MenuListComposition />
          <div className={classes.formLinks}>
            <Typography
              className={classes.formLabel}
              style={{ padding: "10px 10px 10px 30px", cursor: "pointer" }}
              component="a"
              onClick={handleLoginNavigation}
            >
              Login
            </Typography>
            <span>&nbsp; / &nbsp;</span>
            <a
              className={classes.formLabel}
              href="https://forms.office.com/r/LxvmVzs9Rm"
              style={{ padding: "10px 30px 10px 10px" }}
              target="_blank"
            >
              Register
            </a>
          </div>
        </div>
        <div className={classes.content}>
          <div className={classes.left_content}>
            <Typography className={classes.welcome} variant="h4" component="h4">
              Welcome <br /> Tenant Partners!
            </Typography>
            <p>
              Let us help you grow your online and offline business together.
            </p>
          </div>
          <div className={classes.right_content}>
            <img className={classes.onlineStoreImage} src={OnlineStore} />
          </div>
        </div>
        <div className={classes.malls}>
          <h3>SM Malls Online is available in the following malls</h3>
          <Slider {...settings}>
            {activeMalls &&
              activeMalls.map((mall, index) => (
                <div key={index}>
                  <div className={classes.mall}>
                    <img className={classes.mallCheck} src={checkMark} />
                    <span>{mall.node.name}</span>
                  </div>
                </div>
              ))}
          </Slider>
        </div>
        <div className={classes.signupWrapper}>
          <div className={classes.signup}>
            <img className={classes.smWelcomeImage} src={smWelcome} />
            <div className={classes.signupContent}>
              <p>Be part of our growing family!</p>
              <br />
              <a href="https://forms.office.com/r/LxvmVzs9Rm" target="_blank">
                Sign up now!
              </a>
            </div>
          </div>
        </div>
        <div className={classes.smOnline}>
          <h3>SM Malls Online supports you from the very start</h3>
          <div className={classes.smOnlinesupports}>
            <div className={classes.smOnlinesupport}>
              <img
                className={classes.smOnlinesupportImage}
                src={launchPackageIcon}
              />
              <p>Launch Package for marketing mileage in-mall and online</p>
            </div>
            <div className={classes.smOnlinesupport}>
              <img
                className={classes.smOnlinesupportImage}
                src={accountManagementIcon}
              />
              <p>24/7 Account Management and brand consultancy</p>
            </div>
            <div className={classes.smOnlinesupport}>
              <img
                className={classes.smOnlinesupportImage}
                src={inMallSupportIcon}
              />
              <p>In-mall support and operations</p>
            </div>
          </div>
        </div>
        <div className={classes.smFooter}>
          <Link to="/">
            <img
              alt="SM Footer Logo"
              src={smLogoWhite}
              className={classes.smFooterLogo}
            />
          </Link>
          <p>
            SM Malls Online is the newest online shopping app of SM Supermalls.
            Shop from trusted retail brands, restaurants, and Cyberzone. Have
            all your orders shipped with one delivery fee or choose to pick it
            up in-store. It’s your ultimate shopping companion, bringing the fun
            of SM Malling to your phone!
          </p>
        </div>
      </div>
    </div>
  );
};
Homepage.displayName = "Homepage";
export default Homepage;
